import styled from 'styled-components';
// eslint-disable-next-line no-unused-vars
import _default from '../../themes/default';

export const Container = styled.div`
    background: linear-gradient(180deg, transparent 0%, rgba(133, 76, 230, 0.03) 50%, transparent 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 60px 0;
`;

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1350px;
    padding: 10px 20px 100px 20px;
    gap: 16px;
    @media (max-width: 960px) {
        flex-direction: column;
    }
`;

export const Title = styled.div`
    font-size: 48px;
    text-align: center;
    font-weight: 700;
    margin-top: 20px;
    background: linear-gradient(135deg, ${({ theme }) => theme.text_primary} 0%, ${({ theme }) => theme.primary} 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 36px;
    }
`;

export const Desc = styled.div`
    font-size: 18px;
    text-align: center;
    max-width: 600px;
    color: ${({ theme }) => theme.text_secondary};
    line-height: 1.6;
    @media (max-width: 768px) {
        margin-top: 12px;
        font-size: 16px;
    }
`;

export const ToggleButtonGroup = styled.div`
    display: flex;
    background: rgba(23, 23, 33, 0.6);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(133, 76, 230, 0.2);
    color: ${({ theme }) => theme.text_primary};
    font-size: 16px;
    border-radius: 50px;
    font-weight: 500;
    margin: 28px 0px;
    padding: 6px;
    gap: 4px;
    @media (max-width: 768px) {
        font-size: 12px;
        flex-wrap: wrap;
        justify-content: center;
        border-radius: 16px;
    }
`

export const ToggleButton = styled.div`
    padding: 10px 20px;
    border-radius: 50px;
    cursor: pointer;
    transition: all 0.3s ease;
    color: ${({ active, theme }) => active ? theme.text_primary : theme.text_secondary};
    background: ${({ active, theme }) => active ? `linear-gradient(135deg, ${theme.primary}, #6366f1)` : 'transparent'};
    box-shadow: ${({ active }) => active ? '0 4px 15px rgba(133, 76, 230, 0.3)' : 'none'};
    &:hover {
        color: ${({ theme }) => theme.text_primary};
        background: ${({ active, theme }) => active ? `linear-gradient(135deg, ${theme.primary}, #6366f1)` : 'rgba(133, 76, 230, 0.1)'};
    }
    @media (max-width: 768px) {
        padding: 8px 14px;
        border-radius: 8px;
    }
`
export const Divider = styled.div`
    width: 0;
    background: transparent;
`


export const CardContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 32px;
    flex-wrap: wrap;
    margin-top: 20px;
    // display: grid;
    // grid-template-columns: repeat(3, 1fr);
    // grid-gap: 32px;
    // grid-auto-rows: minmax(100px, auto);
    // @media (max-width: 960px) {
    //     grid-template-columns: repeat(2, 1fr);
    // }
    // @media (max-width: 640px) {
    //     grid-template-columns: repeat(1, 1fr);
    // }
`;
